import { render, staticRenderFns } from "./CSwitch.vue?vue&type=template&id=5bcea8a0&"
import script from "./CSwitch.vue?vue&type=script&lang=js&"
export * from "./CSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\270b-ariq\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bcea8a0')) {
      api.createRecord('5bcea8a0', component.options)
    } else {
      api.reload('5bcea8a0', component.options)
    }
    module.hot.accept("./CSwitch.vue?vue&type=template&id=5bcea8a0&", function () {
      api.rerender('5bcea8a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/common/CSwitch.vue"
export default component.exports